//
// xRef Alternatives Table
// ---------------------------------------------------------------------------

'use strict';

const config = {
    copyEvents: 'click touchstart',
    tableTarget: '.c-table--alternatives',
    buttonTarget: '.js-copy-button',
    parentTarget: 'tr',
    dataElement: 'td',
    exclusionClass: '.exclude-from-copy',
    copiedClassName: 'c-xref-alternatives--copied-row'
};

let table = $(config.tableTarget);

if (table.length === 1 && document.queryCommandSupported('copy')) {
    table.on(config.copyEvents, config.buttonTarget, function (event) {
        event.preventDefault();

        try {
            let button = $(event.target);

            const parent = button.closest(config.parentTarget);

            const targets = parent.find(config.dataElement).not(config.exclusionClass);

            const selection = window.getSelection();

            selection.removeAllRanges();

            if (targets.length < 1) {
                throw new Error("No copy target found on the page");
            }

            const range = document.createRange();

            range.setStartBefore(targets.first()[0]);
            range.setEndAfter(targets.last()[0]);

            selection.addRange(range);

            // Reset animation.
            button.removeClass(config.copiedClassName);

            if (!document.execCommand('copy')) {
                throw new Error("Cannot copy text to the clipboard");
            }

            selection.removeAllRanges();
            button.addClass(config.copiedClassName);
        } catch (err) {
            console.error(err);
        }
    });
}



// WEBPACK FOOTER //
// ./src/js/components/xref-alternatives.js